import { useQuery } from '@tanstack/react-query';
import { getInvoiceLogo } from 'Services/invoices';
import { trackError } from 'Utils/errorMonitoring';

export default function useInvoiceLogo(options = {}) {
    const { data: invoiceLogo, isLoading } = useQuery({
        queryKey: ['invoice-logo'],
        queryFn: getInvoiceLogo,
        onError: (error) => trackError(error),
        ...options,
    });

    return {
        invoiceLogo,
        isLoading,
    };
}
